// extracted by mini-css-extract-plugin
module.exports = {"activism-page-type":"activism-page-type__aLpoy","bb-sm-feed":"bb-sm-feed__3eTIh","bb-sm-feed__content":"bb-sm-feed__content__n9wcm"};